export const AUTH = 'auth';
export const SIGN_UP_EMAIL = 'signUpEmail';

export const SANDBOX_CHAT_HISTORY = 'sandboxChatHistory';

export const ONBOARDING_SPLIT_RULES = 'splitRules';
export const ONBOARDING_PAYMENT_LINK_INVOICE = 'paymentLinkInvoice';
export const ONBOARDING_SELLER = 'seller';
